// extracted by mini-css-extract-plugin
module.exports = {"energyTxtRight":"installStatDepth1Item_energyTxtRight__CG0D3"};